import React, { Component } from "react";
import { Row, Col, Input } from "antd";
import { withRouter } from "react-router-dom";

var moment = require("moment");
const dateFormat = "YYYY.MM.DD";

class JoinWorkHeader extends Component {
  formRef = React.createRef();
  
  render() {
    if (!this.props.pdata) return <div>Loading...</div>;
    console.log("dat=", moment(this.props.pdata.enddate, dateFormat))
    console.log("date now =", moment(new Date(), dateFormat))
    
    return (
      <div className="mainContainer">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <div className="HeaderLabel" style={{ marginBottom: 15 }}>
            Хамтран ажиллах санал | {this.props.pdata.joinworkname} ({this.props.pdata.joinworkcode})
            </div>
          </Col>
          <Col span={12}>
            <Row justify="end" gutter={[16, 16]}>
              <div className="MidLabel" style={{ marginBottom: 15 }}>
                { moment(this.props.pdata.enddate, dateFormat) <= moment(new Date(), dateFormat) ?
                "Төлөв: " + this.props.pdata.statusname : "Хугацаа дууссан" }
              </div>
            </Row>
          </Col>
        </Row>
        <Row gutter={[16, 16]}> 
          <Col span={6}>
            <div className="Label" style={{ marginBottom: 5 }}>
              Захиалагч
            </div>
            <Input size="middle" disabled="true" value={this.props.pdata.departmentname} />
          </Col>
          <Col span={6}>
            <div className="Label" style={{ marginBottom: 5 }}>
              Төрөл
            </div>
            <Input size="middle" disabled="true" value={this.props.pdata.tendertypename} />
          </Col>
          <Col span={6}>
            <div className="Label" style={{ marginBottom: 5 }}>
              Зарлах огноо
            </div>
            <Input size="middle" disabled="true" value={this.props.pdata.startdate} />
          </Col>
          <Col span={6}>
            <div className="Label" style={{ marginBottom: 5 }}>
              Дуусах огноо
            </div>
            <Input size="middle" disabled="true" value={this.props.pdata.enddate} />
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: 5 }}> 
          <Col span={12}>
            <div className="Label">Ажил хийгдэх байршил</div>
            <Input size="middle" disabled="true" value={this.props.pdata.worklocation} />
          </Col>
          <Col span={12}>
            <div className="Label">Ажил хийгдэх хугацаа</div>
            <Input size="middle" disabled="true" value={this.props.pdata.workduration} />
          </Col>
        </Row>
      </div> 
    );
  }
}

export default withRouter(JoinWorkHeader);
